import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@hooks/redux-hooks/hooks';
import { selectLastLavoratore, selectLavoratore, selectToken, setupContratto } from '@commons/core.slice';
import { LavoratoreFilterSelection, useLazyGetLavoratoreQuery, useLazyGetLavoratoriQuery } from '@commons/features/lavoratore/lavoratore.api';
import { LavoratoreRecord } from '@commons/mapping/LavoratoreRecord';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { SerializedError } from '@reduxjs/toolkit';
import { TokenRecord } from '@commons/mapping/TokenRecord';

export const useLavoratore = () => {
  const contratto: LavoratoreRecord | null = useAppSelector(selectLavoratore);
  const lastContratto: Pick<LavoratoreRecord, 'id'> | null = useAppSelector(selectLastLavoratore);
  const { idAzienda, idAziendaMaster }: TokenRecord = useAppSelector(selectToken);
  const [getTrigger] = useLazyGetLavoratoreQuery();
  const [getTriggerLavoratori] = useLazyGetLavoratoriQuery();
  const [error, setError] = useState<FetchBaseQueryError | SerializedError | string>();

  const dispatch = useAppDispatch();

  useEffect(() => {
    //console.log('useLavoratore effect!',lastContratto, idAzienda, idAziendaMaster);
    (async () => {
      if (!contratto) {
        if (lastContratto) {
          console.log('USO CONTRATTO DA PERSIST DATA!!!');
          const { data, isSuccess, isError, error } = await getTrigger(
            { idDip: lastContratto.id },
            false,
          );

          if (isError) {
            const errorMessage = error ? error : 'Errore generico';
            setError(errorMessage);
          }

          if (isSuccess) {
            dispatch(setupContratto(data));
          }
        } else {
          console.log('CERCO CONTRATTO DA LISTA CONTRATTI');
          const filterOptions = {
            idAzienda,
            idAziendaMaster,
            tipo: 'flat',
            iniziale: '*',
            tutti: 'all',
            inForzaSection: undefined,
            hiredSection: undefined,
            firedSection: undefined,
            inForza: undefined,
            hired: undefined,
            fired: undefined,
            hiredDataDa: null,
            hiredDataA: null,
            firedDataDa: null,
            firedDataA: null,
            forceDataDa: null,
            forceDataA: null,
            qualifiche: undefined,
            start: 0,
            length: 0,
            mode: 'DataTables',
            view: 'Grid',
          } as Partial<LavoratoreFilterSelection>;

          const { data: contratti } = await getTriggerLavoratori(filterOptions);
          if (contratti?.data) {
            let contrattoSelezionato: LavoratoreRecord | undefined = undefined;

            // Seleziono primo contratto attivo (lavoratore in forza alla data).
            for (const contratto of contratti?.data) {
              if (!contrattoSelezionato && !LavoratoreRecord.isFired(contratto)) {
                contrattoSelezionato = contratto;
                break;
              }
            }
            // Se non ho trovato un contratto, seleziono ultimo contratto della lista.
            if (!contrattoSelezionato) {
              contrattoSelezionato = contratti.data[contratti.data.length - 1];
              //contrattoSelezionato = contratti.data[0];
            }

            dispatch(setupContratto(contrattoSelezionato));
          }
        }
      } else {
        console.log('USO CONTRATTO CORRENTE!');
      }
    })();
  }, [dispatch, contratto, lastContratto, idAzienda, idAziendaMaster, getTrigger, getTriggerLavoratori]);

  return { contratto, error };
};